export default {
  login: {
    校友: 'ALUMNI',
    用户登录: 'Sign In',
    忘记登录账号: 'Find Your Account',
    忘记密码: 'Forget Password?',
    请输入用户名: 'Please enter your UWC email',
    请输入密码: 'Please enter your password',
    我已阅读: 'I have read and agree to abide by',
    用户协议: 'The User Agreement'
  },
  navbar: {
    活动: 'Events',
    聚会: 'Reunion',
    退出: 'Logout'
  },
  events: {
    navside: {
      活动中心: 'Events Center',
      进行中活动: 'Ongoing Events',
      结束的活动: 'Ended Events'
    },
    list: {
      去申请: 'Go to view',
      查看: 'Review'
    }
  },
  reunion: {
    navside: {
      已结束的聚会: 'Ended Reunions',
      返回当前聚会: 'Return to current reunion'
    }
  },

  help: {
    navside: {
      帮助中心: 'Help Center',
      找回密码: 'Retrieve your password',
      查找账号: 'Find Your Account'
    },
    findpwd: {
      请输入: 'please enter your mail',
      邮箱地址: 'Email address',
      确认提交: 'Submit'
    },
    findaccout: {
      请输入: '请输入',
      UWC入学年份: 'Enrollment Year of UWC',
      UWC毕业年份: 'Graduation Year of UWC',
      姓名全名: 'Full Name (Chinese students please fill in Chinese)',
      出生日期: 'Date of Birth',
      确认提交: 'Submit'
    },
    resetpwd: {
      新密码: 'New Password',
      确认新密码: 'Confirm Password  '
    }
  },
  mine: {
    navside: {
      用户中心: 'User Center',
      我的信息: 'My Profile',
      我的活动: 'My Events',
      修改密码: 'Change Password'
    },
    profile: {
      用户照片: 'PROFILE PHOTO',
      用户资料: 'Detailed Information',
      请输入: 'please enter...',
      UWC入学年份: 'Enrollment Year of UWC',
      UWC毕业年份: 'Graduation Year of UWC',
      理事会: 'National Committee',
      名字: 'First Name (Chinese students please fill in pinyin)',
      姓: 'Last Name (Chinese students please fill in pinyin)',
      全名: 'Full Name (Chinese students please fill in Chinese)',
      昵称: 'Preferred Name',
      邮箱: 'Preferred Email Address',
      UWC学校邮箱: 'UWC Email Address',
      出生日期: 'Date of Birth',
      性别: 'Gender',
      国籍: 'Nationality',
      如果从常熟UWC: `If you graduated from UWC Changshu China's FP program then continued at another UWC, please note the UWC you graduated from for the IBDP years.`,
      '大学/学院': 'University/College',
      '专业/领域': 'Major/Area of Concentration',
      工作领域: 'Work Field',
      大学毕业年份: 'Graduation Year of University/College',
      '就职（如适用）': 'Employer (if applicable)',
      '实习（如适用）': 'Internship (if applicable)',
      目前所在国家: 'Current Location(Country)',
      目前所在省份: 'Current Location(Province)',
      目前所在城市: 'Current Location(City)',
      联系电话: 'Contact Number',
      社交软件: 'Preferred Social Media',
      '社交账号（可选）': 'Account Number of Social Media (optional)',
      '我愿意回馈 UWC': 'I would like to give back to the UWC movement',
      我愿意成为演讲嘉宾: 'I would like to be a guest-speaker',
      其他志愿活动: 'Other volunteer activities',
      保存修改: 'Save Change',
      是: 'Yes',
      否: 'No'
    },
    changepwd: {
      请输入: 'please enter...',
      当前密码: 'Current Password',
      新密码: 'New Password',
      确认新密码: 'Confirm New Password',
      保存修改: 'Submit'
    }
  },
  tip: {
    请输入正确邮箱地址: 'Please enter a valid email address',
    修改成功: 'Form modified successfully',
    邮件已发送: 'The email has been sent, please check the email in your mailbox!',
    邮件不存在: 'The email address does not exist',
    密码重置成功: 'Reset successfully.',
    密码重置失败: 'The corresponding user information was not found.',
    登录失败: 'Login failed, please check whether the account password is correct!',
    密码修改成功: 'The password is successfully changed, please log in again.',
    验证码错误: 'Verification code error.',
    用户不存在: 'User does not exist.',
    查询成功: 'The query succeeded.',
    必填字段未填写: 'Some fields are Required and cannot be left blank'
  },
  form: {
    我要报名: 'Sign up',
    已报名: 'Already registered: Review'
  },
  page: {
    校友录: 'ALUMNI',
    我的资料: 'My Profile',
    我的活动: 'My Events',
    用户协议: 'User Agreement',
    我同意: 'I agree',
    我不同意: 'I disagree'
  },
  psw: {
    密码验证:
      'at least 8-16 characters, at least 1 uppercase letter, 1 lowercase letter and 1 number, the rest can be any character',
    确认密码: 'two passwords do not match'
  }
}
